var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ProjectTypeIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 34,
    glyphHeight: 68
  }), React.createElement("path", {
    d: "M17 54.8696C19.3052 54.8696 21.1739 53.0008 21.1739 50.6956C21.1739 48.3905 19.3052 46.5217 17 46.5217C14.6948 46.5217 12.826 48.3905 12.826 50.6956C12.826 53.0008 14.6948 54.8696 17 54.8696Z"
  }), React.createElement("path", {
    d: "M17 34C7.81737 34 0.304321 41.513 0.304321 50.6957C0.304321 59.8783 7.81737 67.3913 17 67.3913C26.1826 67.3913 33.6956 59.8783 33.6956 50.6957C33.6956 41.513 26.1826 34 17 34ZM17 61.7565C10.9478 61.7565 5.93911 56.7478 5.93911 50.6957C5.93911 44.6435 10.9478 39.6348 17 39.6348C23.0522 39.6348 28.0608 44.6435 28.0608 50.6957C28.0608 56.7478 23.0522 61.7565 17 61.7565Z"
  }), React.createElement("path", {
    d: "M17 0.817383C8.65214 0.817383 1.97388 7.49564 1.97388 15.8435C1.97388 24.1913 8.65214 30.8696 17 30.8696C25.3478 30.8696 32.0261 24.1913 32.0261 15.8435C32.0261 7.49564 25.3478 0.817383 17 0.817383ZM14.7043 23.1478L13.4521 21.8956L12.2 20.6435L7.39997 15.8435L9.69562 13.3391L14.4956 18.1391L23.8869 8.33042L26.1826 10.8348L14.7043 23.1478Z"
  }));
};
export var ProjectTypeIconGlyph = function (props) {
  return React.createElement(ProjectTypeIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};